<template>
  <div>
    <div class="top-section">
      <b-row>
        <b-col cols="6">
          <h3 class="heading">Welcome {{ getUserDetails.name }}</h3>
        </b-col>
        <b-col cols="6" class="text-right">
          <b-button size="md" variant="primary" @click="goToAddCourse">
            <font-awesome-icon icon="plus" size="xs" />
            <span class="ml-2">Add Courses</span>
          </b-button>
        </b-col>
      </b-row>
    </div>
    <div class="sales-chart-wrapper">
      <b-row>
        <b-col cols="6">
          <b-card>
            <div class="sales-chart-item">
              <div class="image">
                <img
                  src="data:image/png;base64,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"
                  alt=""
                />
              </div>
              <div class="text">
                <p>{{ month[new Date().getMonth()] }} Sales</p>
                <span>{{ count }}</span>
              </div>
              <div class="chart"></div>
            </div>
          </b-card>
        </b-col>
        <b-col cols="6">
          <b-card>
            <div class="sales-chart-item">
              <div class="image">
                <img
                  src="data:image/png;base64,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"
                  alt=""
                />
              </div>
              <div class="text">
                <p>Weekly sales</p>
                <span>{{ count }}</span>
              </div>
              <div class="chart"></div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <section class="sales-analysis-wrapper">
      <div class="top-section">
        <b-row>
          <b-col cols="6">
            <h3 class="heading">Sales analysis</h3>
          </b-col>
          <b-col cols="6" class="text-right">
            <b-dropdown split right text="Aug 01 - 30" class="m-2">
              <b-dropdown-item href="#">Jul 01 - 30</b-dropdown-item>
              <b-dropdown-item href="#">Jun 01 - 30</b-dropdown-item>
              <b-dropdown-item href="#">May 01 - 30</b-dropdown-item>
            </b-dropdown>
          </b-col>
        </b-row>
      </div>
    </section>
    <course-listing-table :course-type="Regular"></course-listing-table>
  </div>
</template>

<script>
import CourseListingTable from "../components/courseListingTable";
import { mapGetters } from "vuex";
import { customerApi } from "../../services/customerApi";

export default {
  components: {
    CourseListingTable
  },
  name: "admin-home",
  computed: {
    ...mapGetters("user", [
      "getUserDetails",
      "getTeacherCourses",
      "getTeacherLiveCourses",
      "getTeacherSubscriptions",
      "getFollowingStudents"
    ])
  },
  data() {
    return {
      count: 0,
      Regular: "regular",
      month: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ]
    };
  },
  methods: {
    goToAddCourse() {
      this.$router.push("/admin/add-course");
    },
    getTotalSale() {
      for (let [key, value] of Object.entries(this.getTeacherSubscriptions)) {
        console.warn(key);
        console.warn(value);
        value.forEach(val => {
          this.count = this.count + 1;
        });
      }
    }
  },
  mounted() {
    this.getTotalSale();
    customerApi.getTeacherCourses();
  },
  watch: {
    getTeacherSubscriptions() {
      this.getTotalSale();
    }
  }
};
</script>

<style scoped></style>
